module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('alfresco', {
    attrs: {
      "server-address": ""
    },
    on: {
      "message": _vm.sessionError
    },
    model: {
      value: (_vm.alfSession),
      callback: function($$v) {
        _vm.alfSession = $$v
      },
      expression: "alfSession"
    }
  }), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.messages))]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.alfSession.uploadUrl
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": _vm.sending
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3586ce56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 12
// module chunks = 1